// Breakpoint constants for responsive design
// These values should match the Tailwind config breakpoints

export const BREAKPOINTS = {
  // Screen width breakpoints
  MOBILE_MAX: 1199,        // sm: max-width 768px
  DESKTOP_MIN: 1200,       // lg/xlg: min-width 769px
  SMALL_SCREEN: 1200,     // Reduced font sizes below this
  LARGE_SCREEN: 1800,     // Show additional content above this

  // Height breakpoints for xlg (extra-large)
  XLG_HEIGHT: 1400        // xlg: min-height 1400px (equivalent to lg_tall)
}

// Responsive breakpoint helpers
export const isWithinRange = (value, min, max) => {
  return value >= min && value <= max
}
